
import MyNavbar from "../../component/Navbar/Navbar";

import Sapcharacteristics from "../../sapb1/characteristics/sapb1characteristics";
import Sapcontent from "../../sapb1/sapb1conent/sapb1content";
import Sapneeds from "../../sapb1/Needs/Needs";
import Sapreasons from "../../sapb1/Reasons/Reasons";

import Footer from "../../component/Footer/Footer"

const Sapb1 =() =>{
    return (    
        <>
        <MyNavbar/>
        <Sapcontent/>
        <Sapcharacteristics/>
        <Sapneeds/>
        <Sapreasons/>
        
        <Footer/>
        </>
    )
}

export default Sapb1;